import React from "react";
import Brand from "./Brand/Brand";
import Isotope from "./Isotope/Isotope";
import Support from "./Support/Support";

const Branding = () => {
  return (
    <>
      <Brand />
      <Isotope />
      <Support />
    </>
  );
};

export default Branding;
